import React, {useContext} from 'react'
import {Form, Input} from "antd";
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";

const HeaderName = () => {

    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleNameChange = (value) => {
        let mockResponse = Object.assign({}, recipeById)
        mockResponse.recipe.name = value
        setRecipeById(mockResponse)
    }

    return(
        <React.Fragment>
            <Form.Item
                className={'font-bold'}
                name={'recipeName'}
                label={'Reçete Adı'}
                initialValue={recipeById.recipe.name}
            >
                <Input onChange={(event => handleNameChange(event.target.value))} />
            </Form.Item>
        </React.Fragment>
    )
}
export default HeaderName